import {
  GET_CONTENT_ITEMS,
  CREATE_CONTENT_ITEM,
  UPDATE_CONTENT_ITEM,
  UPDATE_CONTENT_STEP,
  DELETE_CONTENT_ITEM,
  GET_TIMELINE,
  GET_DELAYS,
  GET_METRICS,
  CONTENT_LOADING,
  NOTION_SEARCH_RESULTS,
  NOTION_LOADING,
  GET_ALL_FOCUSES,
  CREATE_FOCUS,
  UPDATE_FOCUS,
  DELETE_FOCUS,
  GET_NOTION_PAGES,
  NOTION_PAGES_LOADING,
  CREATE_ITEM_FROM_NOTION,
  SET_PUBLISH_DATE,
  SET_ITEM_STATUS,
  RETRY_SYNC,
} from "../actions/types";

const initialState = {
  items: [],
  timeline: [],
  delays: null,
  metrics: null,
  loading: false,
  notionResults: [],
  notionLoading: false,
  focuses: [],
  notionPages: {},       // { linkedin: [...], blog: [...], videos: [...], github_projects: [...] }
  notionPagesLoading: {},
};

const updateItem = (state, item) => ({
  ...state,
  items: state.items.map((i) => (i._id === item._id ? item : i)),
  timeline: state.timeline.map((i) => (i._id === item._id ? item : i)),
});

export default function contentReducer(state = initialState, action) {
  switch (action.type) {
    case CONTENT_LOADING:
      return { ...state, loading: true };

    case GET_CONTENT_ITEMS:
      return { ...state, items: action.payload, loading: false };

    case CREATE_CONTENT_ITEM:
      return {
        ...state,
        items: [action.payload, ...state.items],
        timeline: [action.payload, ...state.timeline],
      };

    case UPDATE_CONTENT_ITEM:
    case UPDATE_CONTENT_STEP:
      return updateItem(state, action.payload);

    case DELETE_CONTENT_ITEM:
      return {
        ...state,
        items: state.items.filter((i) => i._id !== action.payload),
        timeline: state.timeline.filter((i) => i._id !== action.payload),
      };

    case GET_TIMELINE:
      return { ...state, timeline: action.payload, loading: false };

    case GET_DELAYS:
      return { ...state, delays: action.payload };

    case GET_METRICS:
      return { ...state, metrics: action.payload };

    case NOTION_LOADING:
      return { ...state, notionLoading: true };

    case NOTION_SEARCH_RESULTS:
      return { ...state, notionResults: action.payload, notionLoading: false };

    case GET_ALL_FOCUSES:
      return { ...state, focuses: action.payload };

    case CREATE_FOCUS:
      return { ...state, focuses: [action.payload, ...state.focuses] };

    case UPDATE_FOCUS:
      return {
        ...state,
        focuses: state.focuses.map((f) =>
          f._id === action.payload._id ? action.payload : f
        ),
      };

    case DELETE_FOCUS:
      return {
        ...state,
        focuses: state.focuses.filter((f) => f._id !== action.payload),
      };

    // Notion browsing
    case NOTION_PAGES_LOADING:
      return {
        ...state,
        notionPagesLoading: { ...state.notionPagesLoading, [action.payload]: true },
      };

    case GET_NOTION_PAGES:
      return {
        ...state,
        notionPages: { ...state.notionPages, [action.payload.databaseKey]: action.payload.results },
        notionPagesLoading: { ...state.notionPagesLoading, [action.payload.databaseKey]: false },
      };

    case CREATE_ITEM_FROM_NOTION: {
      const newItem = action.payload;
      // Remove from notionPages (it's now in the planner)
      const dbKey = newItem.notion?.databaseKey;
      const updatedPages = dbKey && state.notionPages[dbKey]
        ? { ...state.notionPages, [dbKey]: state.notionPages[dbKey].filter((p) => p.notionPageId !== newItem.notion.pageId) }
        : state.notionPages;
      return {
        ...state,
        items: [newItem, ...state.items],
        timeline: [newItem, ...state.timeline],
        notionPages: updatedPages,
      };
    }

    case SET_PUBLISH_DATE:
    case SET_ITEM_STATUS:
    case RETRY_SYNC:
      return updateItem(state, action.payload);

    default:
      return state;
  }
}
